import { render, staticRenderFns } from "./scope121.vue?vue&type=template&id=0a715fc4&scoped=true"
import script from "./scope121.vue?vue&type=script&lang=js"
export * from "./scope121.vue?vue&type=script&lang=js"
import style0 from "./scope121.vue?vue&type=style&index=0&id=0a715fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a715fc4",
  null
  
)

export default component.exports